const en = {
    'hkidr.hkidr':'HKIDR Info',
    'hkidr.accountId':'Account ID',    
    'hkidr.accountName':'Account Name (English)',
    'hkidr.invalidAccountId': 'Invalid Account ID',
    'hkidr.invalidAccountName': 'Invalid Account Name',
    'hkidr.captcha': 'Captcha',
    'hkidr.invalidCaptcha': 'Invalid Captcha',
    'hkidr.uploadconsent':'HKIDR AND OTCR FORM*',
    'hkidr.donwloadconsent':'Download form (Here)',    
    'hkidr.docType':'Document Type',
    'hkidr.doc':'Document',
    'hkidr.HKID':'HK ID Card',    
    'hkidr.PP':'Passport',
    'hkidr.CONSENT':'HKIDR and OTCR Form',
    'hkidr.NTID':'National ID',
    'hkidr.NTIDF':'Document (Front)',
    'hkidr.NTIDB':'Document (Back)',
    'hkidr.OTH':'Other',
    'hkidr.':' ',
    'hkidr.accountNo': 'Account Number',    
    'hkidr.uploadFileNotice': 'I/We would like to update my/our identification data and provide cop(ies) of my/our  up-to-date identity document(s) to KGIA (If applicable):',
    'hkidr.jointAccUploadFileNotice': 'Please update your personal information for KGI (if any):',
    'hkidr.invalidDocType':'Invalid Document Type',
    'hkidr.invalidFile':'Invalid File',
    'hkidr.invalidAcc':'Invalid Account Number',
    'hkidr.invalidConsent':'Invalid Consent Status',
    'hkidr.invalideSignature':'Invalid e-Signature',
    'hkidr.invalidIssuePlace':'Invalid Issue Place',    
    'hkidr.browse':'Browse',
    'hkidr.add':'Add',
    "hkidr.concentdesp": "I/We agreed and confirmed following statments:",
    "hkidr.tc": "discliamer 12345678",
    'general.notes': 'Notes',
    'general.submit': 'Submit',    
    'general.formAuth':'KGI eForm Auth',
    'hkidr.idDoc':'Identity Document',
    'hkidr.idIssuePlace': 'Issue Place',
    'hkidr.idNo': 'Identity Number',
    'hkidr.accName': 'Account Name',
    'hkidr.remark1':'The consent form and the copy of your identity document (if applicable) must be duly signed by you; otherwise, we may not accept your request.',
    'hkidr.remark2':'Your account information will be updated according to the identification document(s) uploaded on this form.',
    'hkidr.remark3':'Fields marked with an asterisk (*) must be filled; otherwise, we may not accept your request.',
    'hkidr.remark4':'Please submit this form before 16:00 HK time on a business day. Requests made after the cut-off time or on Saturday, Sunday and public holidays will be processed on the next business day. ',
    'hkidr.eSignature':"e-Signature",
    'hkidr.requestUpdate':"Update Identity Document",
    'hkidr.yes':"Yes",
    'hkidr.no':"No",
    'general.confirmation':'Confirmation',
    'general.cancel':'Cancel',
    'general.ok':'Submit',
    'general.close':'Close',
    'hkidr.fileinstruction':'Please sign at the bottom of the copy of your identification document (front) before uploading it.',
    'hkidr.sample':'Sample',
    'hkidr.result':'Result',
    'hkidr.success':'Submit Success',
    'hkidr.fail':'Submit failed. Please try again or contact your Investment Representative.',
    'hkidr.LEI':'LEI document',
    'hkidr.COI':'Certificate of incorporation',
    'hkidr.BRC':'Business registration certificate',
    'hkidr.OTHS':'Other equivalent identity document',
    'hkidr.maxexceed': 'Exceed the maximum limit',
    'hkidr.verifyErr_1':' ',
    'hkidr.verifyErr_0':' ',
    'hkidr.verifyErr_-1':'Invalid Captcha Code',
    'hkidr.verifyErr_-2':'Please enter a valid Account ID and Account Name(English)',
    'hkidr.verifyErr_-3':'Please enter a valid Account ID and Account Name(English)',
    'hkidr.verifyErr_-4':'Verify failed,please contact your Investment Representative.',
    'hkidr.consented':'Thank you for using KGI e-Service, your submission has been sent.',
    'hkidr.invalidFileType':'Invalid File: only accept jpg/gif/png/pdf',
    'hkidr.invalidFileSize':'Invalid File: file size exceeds the maximum limit(10MB)',
};   
export default en;